import React from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

export const Textfield = props => {
    return (
        <TextField
            required={props.required?props.required:null}
            error={props.error?props.error:null}
            helperText={props.helperText?props.helperText:''}
            className={props?props.className:'textfield'}
            name={props.name?props.name:''}
            label={props.label}
            type={props.type}
            select={props.select}
            rowsMax={props.rowsMax}
            value={props.value}
            onChange={props.onChange}
        >
            {props.array_options?
                props.array_options.map((option, index) => (
                    <MenuItem key={index} name={props.name} value={option.titel}>
                        {option.titel}
                    </MenuItem>
                ))
            :''}
        </TextField>
    )
}